import React, { Component } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'

import requireLogin from '../auth/requireLogin.js'
import { selectJiraUser, selectADUserInfo } from '../auth/reducer'
import { Container, PageTitle, H1} from '../components/index.js'
import Avatar, { AvatarItem } from '@atlaskit/avatar'
import AccessStatus from '../accessSelfService/AccessStatus'

export class UserPage extends Component { 

  render () {
    let { jiraUser, adUser} = this.props      
    return (
      <div>
        <PageTitle title='User' />    
        <Container section>        
        <H1>User</H1>
          <AvatarItem
              avatar={<Avatar src={jiraUser && jiraUser.avatarUrls ? jiraUser.avatarUrls['48x48'] : null} size='large' />}
              key={jiraUser ? jiraUser.emailAddress: adUser.email }
              primaryText={jiraUser ? jiraUser.displayName: adUser.firstName + ' ' + adUser.lastName}
              secondaryText={jiraUser ? jiraUser.emailAddress: adUser.email}
              enableTextTruncate={true}
          />
          {!jiraUser ? null : !jiraUser.avatarUrls ? <span className='u-sm-ib p4-sm mb-2-sm u-va-b'>
          Your user icon is pulled from JIRA. <br />
          Reasons one is not displayed: <br />
          1) You don't have a JIRA account - Not needed to use this tool. <br />
          2) You haven't added an Avatar to your profile
          </span> : null}
          {
            <div className='section-header' >Application Access Status
            <AccessStatus username={adUser.username} />
            </div>
          }          
        </Container>
      </div>
    )    
  }
}

export default compose(
  requireLogin('User'),
  connect(state => {
    return {      
      jiraUser: selectJiraUser(state),
      adUser: selectADUserInfo(state),
    }
  }, { }))(UserPage)



// WEBPACK FOOTER //
// ./client/src/user/UserPage.js